module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av736-7eb4314c733084195fabebf296311757.jpg";